import React from 'react';
import ChatInterface from './components/ChatInterface.tsx';

const App: React.FC = () => {
  return (
    <div className="App">
      <ChatInterface />
    </div>
  );
};

export default App;
